"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Headers = void 0;
/**
 * Класс для работы с HTTP Заголовками.
 *
 * Внутри заголовки хранятся в виде массива, так как в браузере
 * используется XMLHttpRequest и нет возможности разом установить
 * все заголовки.
 *
 * @export
 * @class Headers
 * @implements {IHeaders}
 */
var Headers = /** @class */ (function () {
    function Headers(headers) {
        if (Array.isArray(headers)) {
            this.headers = headersToLowerCase(headers);
        }
        else {
            this.headers = headersToLowerCase(Object.entries(headers));
        }
    }
    Headers.prototype.get = function (header) {
        var lowerHeaderName = header.toLowerCase();
        var result = this.headers.find(function (_a) {
            var _b = __read(_a, 1), name = _b[0];
            return name === lowerHeaderName;
        });
        return (result === null || result === void 0 ? void 0 : result.length) && result[1];
    };
    Headers.prototype.set = function (header, value) {
        var lowerHeaderName = header.toLowerCase();
        var index = this.headers.findIndex(function (_a) {
            var _b = __read(_a, 1), name = _b[0];
            return name === lowerHeaderName;
        });
        if (index !== -1) {
            this.headers[index] = [lowerHeaderName, value];
        }
        else {
            this.headers.push([lowerHeaderName, value]);
        }
    };
    Headers.prototype.toArray = function () {
        return this.headers;
    };
    Headers.prototype.toMap = function () {
        return Object.fromEntries(this.headers);
    };
    Headers.prototype.inject = function (rawHeaders) {
        var headers = Array.isArray(rawHeaders)
            ? headersToLowerCase(rawHeaders)
            : headersToLowerCase(Object.entries(rawHeaders));
        this.headers = this.headers.filter(function (_a) {
            var _b = __read(_a, 1), name = _b[0];
            return !headers.some(function (_a) {
                var _b = __read(_a, 1), iHeader = _b[0];
                return iHeader === name;
            });
        }).concat(headers);
    };
    return Headers;
}());
exports.Headers = Headers;
function headersToLowerCase(headers) {
    return headers.map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        return [key.toLowerCase(), value];
    });
}
//# sourceMappingURL=Headers.js.map